export default __webpack_public_path__ + "static/media/forest.c53f2e27.svg";